module.exports = __webpack_public_path__ + "img/coupon_tutorial_imymerry02.dd55eb55.png";